
    <kv-customer-card-search
      [showBack]="false"
      (onCardSelect)="showDomiciliation($event)"
    ></kv-customer-card-search>
    <p-dialog *ngIf="selectedCard && filteredStoresByChannel && currentStore"
              header="{{ 'card.domiciliation' | translate }}"
              (onHide)="undoDomiciliation()"
              [(visible)]="showDomiciliationModal"
              [modal]="true"
              [draggable]="false"
              [resizable]="false">
      <kv-card-domiciliation
        [card]="selectedCard"
        [filteredStores]="filteredStoresByChannel"
        [currentStore]="currentStore"
        (onCancel)="undoDomiciliation()"
        (onSave)="performDomiciliation($event)"
      ></kv-card-domiciliation>
    </p-dialog>
  


// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-domiciliation/loyalty-domiciliation-single.component.ts.LoyaltyDomiciliationSingleComponent.html